import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const selectedNodes = map.useSelectedNodes()
    const {canCopyNodeId, copyNodeId} = map.commands
    const nodes = canCopyNodeId(selectedNodes)

    if (0 === nodes.length) {
        return null
    }

    return {
        key: 'copy-node-id',
        label: '复制标识',
        suffix: '',
        onClick: () => copyNodeId(nodes),
    }
}
